import { getNonce } from '../eth-like-util.js'

export const resolveNonce = async ({
  asset,
  forceFromNode,
  fromAddress,
  providedNonce,
  txLog,
  triedNonce,
}) => {
  const nonceFromNode =
    asset.baseAsset?.api?.features?.noHistory || forceFromNode
      ? await getNonce({ asset: asset.baseAsset, address: fromAddress, tag: 'latest' }) // maybe 'pending' to unconfirmed txs
      : 0

  const nonceFromLog = [...txLog]
    .filter((tx) => tx.sent && !tx.dropped && tx.data.nonce != null)
    .reduce((nonce, tx) => Math.max(tx.data.nonce + 1, nonce), 0)

  return Math.max(
    nonceFromNode,
    nonceFromLog,
    providedNonce ?? 0,
    triedNonce === undefined ? 0 : triedNonce + 1
  )
}
